import './modal-qr.scss';
//library
import { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
//shared
import Modal from '../modal-alert/modal-alert';
import { GENERATE_QR } from '../../graphql/branch';
//material

function ModalQR({ modalQR, branchId }: { modalQR: boolean, branchId: number }) {
    const [statusModal, changeStateModal] = useState(true);
    let branchQr: any;
    
    const isValidBranchId = branchId && branchId > 0 && !isNaN(branchId);
    
    const { data, error } = useQuery(GENERATE_QR, {
        variables: { branchId: branchId },
        skip: !isValidBranchId,
    });

    if (data && data.QrGenerate) branchQr = data.QrGenerate.message;
    if (error) console.log(`Submission error! ${error.message}`);

    useEffect(() => {
        changeStateModal(!statusModal)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modalQR])

    return (
        <Modal
            estatus={statusModal}
            changeStatus={changeStateModal}
            title="Tu código QR"
            showHeader={true}
            buttonCancel={true}
        >
            <div className='content-img-qr'>
                {!isValidBranchId && (
                    <div className="error-message">
                        <p>No se pudo cargar el código QR. Por favor, selecciona una sede válida.</p>
                    </div>
                )}
                {branchQr && isValidBranchId && (
                    <div className="img-qr" contentEditable='true' dangerouslySetInnerHTML={{ __html: data.QrGenerate.message}} ></div>
                )}
            </div>
        </Modal>
    );
};

export default ModalQR;